module.exports = __webpack_public_path__ + "img/activity_2_image.a1245f5e.jpg";